import autobind from 'autobind-decorator';
import { extendObservable, computed } from 'mobx';
import { timeUtils } from '../../../../../../../../../common/utils/timeUtil';
import { ScoreUtil } from '../../../../../../../../../common/utils/scoreUtil';

@autobind
class BasketballMatchRelativeRecordVsRecordModel {
  constructor(data) {
    extendObservable(this, data);
  }

  @computed
  get getTeamData() {
    const { home, away } = this;

    const game = {
      teams: {
        home,
        away,
        league: { name: '' },
        period: home.periodData.length
      }
    };

    return ScoreUtil.getTeamScore(
      game,
      this.status,
      'BASKETBALL',
      home.periodData.length
    );
  }
  @computed
  get quarterArr() {
    let quarters = [
      { key: '1Q', value: 1 },
      { key: '2Q', value: 2 },
      { key: '3Q', value: 3 },
      { key: '4Q', value: 4 }
    ];
    const { period } = this;

    if (period > 4) {
      quarters.push({
        key: `연장`,
        value: 5
      });
    }

    return quarters;
  }

  @computed
  get teams() {
    const { home, away } = this;

    return { home, away };
  }

  @computed
  get sortedHomeScores() {
    const { home } = this;

    return home.periodData.sort((a, b) => a.period - b.period);
  }

  @computed
  get sortedAwayScores() {
    const { away } = this;

    return away.periodData.sort((a, b) => a.period - b.period);
  }

  @computed
  get homeTotalScore() {
    const { home } = this;
    let total = 0;

    home.periodData.forEach((data) => {
      total += data.score;
    });

    return total;
  }

  @computed
  get awayTotalScore() {
    const { away } = this;
    let total = 0;

    away.periodData.forEach((data) => {
      total += data.score;
    });

    return total;
  }

  @computed
  get date() {
    return timeUtils.timeFormatMonthDay(this.startDateTime);
  }

  @computed
  get teamsData() {
    const { home, away } = this;
    const homeScore = ScoreUtil.getTeamTotalScore(home.periodData);
    const awayScore = ScoreUtil.getTeamTotalScore(away.periodData);

    return {
      home: {
        name: home.name,
        score: homeScore,
        winner: homeScore > awayScore
      },
      away: {
        name: away.name,
        score: awayScore,
        winner: awayScore > homeScore
      }
    };
  }

  @computed
  get oddsData() {
    const { odds } = this;

    let result = {
      winLose: {
        home: getOdds(odds.domesticWinLoseOdds, 'WIN'),
        away: getOdds(odds.domesticWinLoseOdds, 'LOSS')
      },
      handicap: {
        option: getOption(odds.domesticHandicapOdds),
        home: getOdds(odds.domesticHandicapOdds, 'HANDICAP_WIN'),
        away: getOdds(odds.domesticHandicapOdds, 'HANDICAP_LOSS')
      },
      unover: {
        option: getOption(odds.domesticUnderOverOdds),
        home: getOdds(odds.domesticUnderOverOdds, 'UNDER'),
        away: getOdds(odds.domesticUnderOverOdds, 'OVER')
      }
    };

    function getOdds(arr, location) {
      const data = arr.filter((item) => item.type === location);
      let result = { odds: 0, hit: false };

      if (data.length > 0) {
        if (!!data[0]) {
          result.odds = isNaN(data[0].odds)
            ? data[0].odds
            : data[0].odds.toFixed(2);
          result.hit = data[0].result === 'HIT';
        }
      }

      return result;
    }

    function getOption(arr) {
      if (arr.length > 0) {
        return arr[0].optionValue;
      } else {
        return null;
      }
    }

    return result;
  }
}

export default BasketballMatchRelativeRecordVsRecordModel;
